module.exports = __webpack_public_path__ + "img/servicioAmbulancia.d53d6f0e.jpg";